<template>
  <b-autocomplete
    v-model="title"
    :data="data"
    icon="magnify"
    placeholder="Select campaign"
    field="title"
    :loading="isFetching"
    @input="getAsyncData"
    @select="option => { selected = option }"
    open-on-focus
    expanded
  >
    <template slot-scope="{ option: campaign }">
      <div class="media">
        <div class="media-content">
          <strong>{{ campaign.id }}</strong>
          <div class="has-text-grey">{{ campaign.title }}</div>
        </div>
      </div>
    </template>
  </b-autocomplete>
</template>


<script>
import debounce from "lodash/debounce";

export default {
  props: {
    type: String,

    url: {
      type: String,
      default: "/admin/api/magazine/campaigns"
    }
  },

  data() {
    return {
      data: [],
      title: "",
      selected: null,
      isFetching: false,
      editAble: false
    };
  },

  created() {
    this.getAsyncData();
  },

  watch: {
    selected(campaign) {
      this.$emit("input", campaign ? campaign.id : null);

      this.$emit("change", campaign);
    }
  },

  methods: {
    clear() {
      this.name = "";
      this.selected = null;
    },

    getAsyncData: debounce(function() {
      this.data = [];
      this.isFetching = true;
      this.$http
        .get(this.url, {
          params: {
            search: this.title,
            "filter[type]": this.type
          }
        })
        .then(({ data }) => {
          data.data.forEach(item => this.data.push(item));
          this.isFetching = false;
        })
        .catch(error => {
          this.isFetching = false;
          throw error;
        });
    }, 300)
  }
};
</script>
